import { render, staticRenderFns } from "./ProjectRubricsPure.vue?vue&type=template&id=d32f8fde&scoped=true&"
import script from "./ProjectRubricsPure.vue?vue&type=script&lang=ts&"
export * from "./ProjectRubricsPure.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectRubricsPure.vue?vue&type=style&index=0&id=d32f8fde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32f8fde",
  null
  
)

export default component.exports